import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.href ? `https://budingmanhua.com${item.href}` : 'https://budingmanhua.com',
        name: item.label,
      },
    })),
  };

  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-xs text-foreground-400">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-1.5">
          {index > 0 && (
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-[10px]"></i>
            </span>
          )}
          {item.href ? (
            <Link to={item.href} className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-600 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}